import moment from "moment-timezone";
import { i18nInstance } from "@/i18n";

const zeroPadLeft = number => {
    if (number.toString().length === 1) {
        return "0" + number;
    } else {
        return number;
    }
};

export default {
    install: function(Vue) {
        Vue.prototype.$moment = moment;

        Vue.filter("momentTime", function(value) {
            return moment
                .utc(value)
                .tz("Europe/Copenhagen")
                .format("HH:mm");
        });
        Vue.filter("momentDate", function(value) {
            return moment
                .utc(value)
                .tz("Europe/Copenhagen")
                .format("D. MMMM YYYY");
        });
        Vue.filter("momentDateAndTime", function(value) {
            return moment
                .utc(value)
                .tz("Europe/Copenhagen")
                .format("D. MMMM YYYY HH:mm");
        });
        Vue.filter("momentMonthYear", function(value) {
            return moment
                .utc(value)
                .tz("Europe/Copenhagen")
                .format("MMMM YYYY");
        });
        Vue.filter("momentFull", function(value) {
            return moment
                .utc(value)
                .tz("Europe/Copenhagen")
                .format("dddd D. MMMM YYYY");
        });
        Vue.filter("momentFullCapitalFirstLetter", function(value) {
            let full = moment
                .utc(value)
                .tz("Europe/Copenhagen")
                .format("dddd D. MMMM YYYY");
            return full.charAt(0).toUpperCase() + full.slice(1);
        });
        Vue.filter("tripTravelTime", function(trip) {
            const fromDate = moment.utc(trip.departureInstant);
            const toDate = moment.utc(trip.arrivalInstant);
            const minuteDiff = toDate.diff(fromDate, "minutes");
            const hourDuration = Math.floor(minuteDiff / 60);
            const minuteDuration = minuteDiff % 60;
            return [
                zeroPadLeft(hourDuration),
                zeroPadLeft(minuteDuration)
            ].join(":");
        });
        Vue.filter("minuteToNiceString", value => {
            const txts = i18nInstance().t("filter_moment");

            let minutes = value;
            let days = Math.floor(minutes / 60 / 24);
            minutes = minutes - days * 24 * 60;
            let hours = Math.floor(minutes / 60);
            minutes = minutes - hours * 60;

            const parts = [];
            if (days > 0)
                parts.push(`${days} ${days === 1 ? txts.day : txts.days}`);
            if (hours > 0)
                parts.push(`${hours} ${hours === 1 ? txts.hour : txts.hours}`);
            if (minutes > 0)
                parts.push(
                    `${minutes} ${minutes === 1 ? txts.minute : txts.minutes}`
                );

            return parts.join(", ").replace(/,([^,]*)$/, " &" + "$1");
        });
    }
};
